import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import { useState } from 'react';
import classNames from 'classnames/bind';
import styles from './TabOnlyElement.module.scss';
import TypographyElement from '../typography/TypographyElement';
import useIsMobile from '@/componentShare/hooks/useIsMobile';

const cx = classNames.bind(styles);

type StyledTabProps = {
  tabs: any[];
  callBackChangeTab: (id: string) => void
}

export default function TabOnlyElement({ tabs, callBackChangeTab }: StyledTabProps) {
  const [tab, setTab] = useState(1);
  const matches = useIsMobile();

  const handleTabChange = (event: React.SyntheticEvent, newTab: number) => {
    setTab(newTab);
  }

  return (
    <>
      <TabContext value={tab}>
        <TabList
          variant="scrollable"
          scrollButtons={matches}
          allowScrollButtonsMobile={matches}
          aria-label="scrollable force tabs example"
          onChange={handleTabChange} className={cx('only-tab-list')}>
          {tabs.map((tab, index) => (
            <Tab onClick={() => { callBackChangeTab(tab) }}
              label={<TypographyElement FontSizeElement='16px' FontWeightElement={700} ColorElement='inherit'>{tab.label}</TypographyElement>}
              value={index + 1} key={index} disableRipple />
          ))}
        </TabList>
      </TabContext>
    </>
  );
}